import { render } from "./FeaturesSection03.vue?vue&type=template&id=c3cb06f4"
import script from "./FeaturesSection03.vue?vue&type=script&lang=js"
export * from "./FeaturesSection03.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__